import React, { useState } from "react";
import { Button, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Checkbox from "@mui/material/Checkbox";
import { updateAuthorization } from "../../redux/user/userSlice";
import { useTranslation } from "react-i18next";
import { API } from "../../utils/http";
import { toast } from "react-toastify";
export default function Authorization(props) {
	const { handleNext, handleBack, renderControls, title, verifier } = props;
	const [error, setError] = useState({});
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const authorization = useSelector((state) => state.user.application.authorization);
	const applicationId = useSelector((state) => state.user.application.personalInformation.id);
	const handleAuthorizationChange = (e) => {
		dispatch(updateAuthorization(e.target.checked));
	};
	const handleNextButton = () => {
		console.log("verify authorization: ", authorization);
		const errors = verifier(authorization);
		console.log(errors);
		if (Object.keys(errors).length === 0) {
			handleNext();
			setError({});
		} else {
			setError(errors);
		}
	};
	const handleClick = (event) => {
		setLoading(true);
		API.get(`/consent-form/${applicationId}`)
			.then((r) => {
				console.log("Successfully got consent");
				const base64Pdf = r.data;

				const binaryString = window.atob(base64Pdf); // Comment this if not using base64
				const bytes = new Uint8Array(binaryString.length);
				const arrayBuffer = bytes.map((byte, i) => binaryString.charCodeAt(i));

				const blob = new Blob([arrayBuffer], { type: "application/pdf" });

				const blobUrl = window.URL.createObjectURL(blob);
				window.open(blobUrl, "_blank");
			})
			.catch((e) => {
				console.log(e);
				toast.error("Could not get consent");
			})
			.finally(() => {
				setLoading(false);
			});
	};
	return (
		<React.Fragment>
			<Typography>{title}</Typography>
			<Grid container>
				<Grid item xs={12} marginBottom={2}>
					<Typography>{t("Please read the following terms and conditions")}</Typography>
				</Grid>
				<Grid item xs={12} marginBottom={2}>
					<Typography>{t("Full Consent Text")}</Typography>
				</Grid>
				<Grid item xs={12} marginBottom={2}>
					<FormControl required error={!!error.authorization}>
						<FormGroup>
							<FormControlLabel
								control={<Checkbox required name="authorization" checked={authorization} onChange={handleAuthorizationChange} />}
								label={t("Yes, I agree")}
							/>
						</FormGroup>
						<FormHelperText
							sx={{
								display: error.authorization ? "initial" : "none",
								fontSize: "1rem",
							}}
						>
							{t("You must check this box if you want to proceed")}
						</FormHelperText>
					</FormControl>
				</Grid>
				<Grid item xs={12} marginBottom={2}>
					<Button variant="outlined" style={{ textTransform: "capitalize" }} onClick={handleClick} disabled={!authorization || loading}>
						{loading ? "Loading..." : "View Consent"}
					</Button>
				</Grid>
			</Grid>
			{renderControls(handleNextButton, handleBack)}
		</React.Fragment>
	);
}
